
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { cloneDeep } from 'lodash';
import { forEach } from 'lodash';
import { isEqual } from 'lodash';
@Component({
  components: {}
})
export default class ContactView extends Vue {
  activeName: any = 'ERP';
  searchKey: any = '';
  searchResult: any = [];
  curTablelist: any = {};
  isExpand: boolean = true;
  tableData: any = [];
  mergeInfoArray:any=[];
  @Getter contactList: any;

  @Action('getContactList') getContactList: Function;

  // filterObj(item: any) {
  //   if (item.ProductName.indexOf(this.searchKey) > -1) {
  //     return true;
  //   }
  //   if (item.hasOwnProperty('Children') && !!item.Children) {
  //     item.Children = item.Children.filter((child: any) => {
  //       if (!item.hasOwnProperty('Children') || !item.Children) {
  //         return child.ProductName.indexOf(this.searchKey) > -1;
  //       } else if (item.hasOwnProperty('Children') && !!item.Children) {
  //         return this.filterObj(child);
  //       }
  //     });
  //     if (item.Children.length > 0) {
  //       return true;
  //     }
  //   } else {
  //     return item.ProductName.indexOf(this.searchKey) > -1;
  //   }
  // }
  // handleSearch() {    
  //   console.log(22);
  //   const scopes = this.$refs.contable;
  //   const list = cloneDeep(this.curTablelist);
  //   this.searchResult = (list as any).Children.filter((item: any) => {
  //     return this.filterObj(item);
  //   });
  //   if(this.searchKey!=''){
  //       this.searchResult=this.searchResult[0].Children[0].Children;
  //   }    
  // }
 
  mounted() {
    // this.activeName = this.$route.query.tab || 'ERP';
    this.searchKey = this.$route.query.tab || '';

    this.getContactList().then(() => {
      setTimeout(() => {
        //console.log(this.contactList);
        //this.curTablelist = this.contactList.infos[0];
        this.tableData=this.contactList.infos;
        //this.handleSearch();
        for (let index = 0; index < this.tableData.length; index++) {
            const element = this.tableData[index];
            if(element.MergesJson)
            {
              var margeInfo= JSON.parse(element.MergesJson);
              for(var i=0;i<margeInfo.length;i++)
              {
                this.mergeInfoArray.push(margeInfo[i]);
              }
            }
        }
      }, 200);
    });
  }
  headFirst({ row, column, rowIndex, columnIndex }){
    if(rowIndex==1)
    {
      return {display:'none'};
    }
    return "background:#99ddff;color:black;";
  }
        
    
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //console.log(row,column,rowIndex,columnIndex);
      var ri=rowIndex+1,ci=columnIndex+2;
      if(row.MergesJson)
      {
        var margeInfo= JSON.parse(row.MergesJson);
        for(var i=0;i<margeInfo.length;i++)
        {
          if(margeInfo[i].FirstRow==ri&&margeInfo[i].FirstColumn==ci)
          {
            var result= {
               rowspan:(margeInfo[i].LastRow-margeInfo[i].FirstRow)+1
              ,colspan:(margeInfo[i].LastColumn-margeInfo[i].FirstColumn)+1
            };
           // console.log(row,column,rowIndex,columnIndex,margeInfo,result,"if");
            return result;
          }else if(margeInfo[i].FirstRow<=ri && margeInfo[i].LastRow >=ri &&margeInfo[i].FirstColumn<=ci && margeInfo[i].LastColumn >=ci){
            var result=  {
              rowspan:0,
              colspan:0
            };
           // console.log(row,column,rowIndex,columnIndex,margeInfo,result,"else");
            return result;
          }
        }
        for(var i=0;i<this.mergeInfoArray.length;i++)
        {
          var margeInfo= this.mergeInfoArray[i];
          if(margeInfo.FirstRow<=ri && margeInfo.LastRow >=ri &&margeInfo.FirstColumn<=ci && margeInfo.LastColumn >=ci){
              var result=  {
                rowspan:0,
                colspan:0
              };
             // console.log(row,column,rowIndex,columnIndex,margeInfo,result,"else-else-if");
              return result;
            }
        }
      }else{
       
        for(var i=0;i<this.mergeInfoArray.length;i++)
        {
          var margeInfo= this.mergeInfoArray[i];
          if(margeInfo.FirstRow==ri&&margeInfo.FirstColumn==ci)
          {
            var result= {
               rowspan:(margeInfo.LastRow-margeInfo.FirstRow)+1
              ,colspan:(margeInfo.LastColumn-margeInfo.FirstColumn)+1
            };
            //console.log(row,column,rowIndex,columnIndex,margeInfo,result,"else-if");
            return result;
          }else if(margeInfo.FirstRow<=ri && margeInfo.LastRow >=ri &&margeInfo.FirstColumn<=ci && margeInfo.LastColumn >=ci){
            var result=  {
              rowspan:0,
              colspan:0
            };
           // console.log(row,column,rowIndex,columnIndex,margeInfo,result,"else-else-if");
            return result;
          }
        }
      }
     
    }
}
